import React, { useState, useEffect, FC, useCallback, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Content from "../../layout/content/Content";
import { Card, Row, Col, Button, Spinner, Alert } from "reactstrap";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import { FormProvider, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  DeleteOutlined,
  UploadOutlined,
  PlusSquareOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Table,
  Collapse as AntCollapse,
  Button as AntButton,
  Descriptions,
  Modal as AntModal,
  Spin,
  Flex,
  Drawer,
  Upload,
  Select,
  Popover,
  DatePicker,
  message,
  Popconfirm,
} from "antd";

import dayjs from "dayjs";
import axios from "axios";
import { nanoid } from "nanoid";
import { Option } from "antd/es/mentions";
import Swal from "sweetalert2";
import CropperComponent from "../components/CropperComponent";
import SignatureModal from "../purchase-orders/SignatureModal";
import usersApis from "../../api/master/users";
import quotationApis from "../../api/master/quotations";
import { useLocation } from "react-router-dom";
import { formatCurrency, formatPreferredBrands } from "../../utils/Utils";
import FormTextArea from "../form-components/TextAreaComponent";
import BulkMaterialUpload from "./BulkMaterialUpload";
import ExportToXlsx from "../../utils/exportToXlsx";
import QuotationApprovalDrawer from "./QuotationApprovalDrawer";

const { Panel } = AntCollapse;

const RFQViewDetails: FC<any> = () => {
  const [disableRegret, setDisableRegret] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [OriginalData, setOriginalData] = useState<any>({});
  const [invoiceableLines, setInvoiceableLines] = useState<any>([]);
  const [sm, setSm] = useState(false);
  const [tab, setTab] = useState("1");
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [attachments, setAttachments] = useState<any>([]);
  const [documentsAttached, setDocumentsAttached] = useState<any>([]);
  const [signature, setSignature] = useState<any>([]);
  const [invoiceSignature, setInvoiceSignature] = useState<any>({});
  const [additionalCharges, setAdditionalCharges] = useState<any>([]);
  const [approvalRequired, setApprovalRequired] = useState("false");
  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });

  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [instructions, setInstructions] = useState("");

  const location = useLocation();
  const rfq = location.state?.rfq;

  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [editingKeys, setEditingKeys] = useState<any[]>([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [editAdditionalCharges, setEditAdditionalCharges] = useState(true);
  const isEditing = (record: any) =>
    editingKeys.includes(record.quotationLineId);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [prefferedStates, setPrefferedStates] = useState<any>([]);
  const [orgId, setOrgId] = useState<any>(null);
  const [paymentTerm, setPaymentTerm] = useState<string | undefined>(undefined);

  const [requiredDOC, setRequiredDOC]: any = useState();

  const [disableCreateQuoteSubmit, setDisableCreateQuoteSubmit] =
    useState(false);

  const [data, setData] = useState<any>([]);
  const [filterData, setFilterData] = useState<any>([]);
  const [uploadedDataErrors, setUploadedDataErrors] = useState<any>([]);
  const [uploadedDataErrorModal, setUploadedDataErrorModal] = useState(false);
  const bulkUploadErrorsRef = useRef<HTMLDivElement>(null);
  const errorRef = useRef<HTMLDivElement>(null);
  const [supplierTermsAndConditions, setsupplierTermsAndConditions] =
    useState<any>("");
  const [gstType, setGstType] = useState<"cgst+sgst" | "igst">("cgst+sgst");
  const [pricingMode, setPricingMode] = useState<string>("");
  const [brandOptions, setBrandOptions] = useState<any[]>([]);
  const [newPreferredBrandsArray, setNewPreferredBrandsArray] = useState<string[]>([]);
  const [newPreferredBrands, setNewPreferredBrands] = useState<string>("");
  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const termsAndConditionsWatch = watch("supplierTermsAndConditions");

  useEffect(() => {
    if (termsAndConditionsWatch) {
      setsupplierTermsAndConditions(termsAndConditionsWatch);
    }
  }, [termsAndConditionsWatch]);

  // Sync preferred brands from OriginalData when data loads
  useEffect(() => {
    const preferredBrandsValue =
      OriginalData?.supplierInfo?.supplierHeader?.supplierPreferredBrands ||
      OriginalData?.quotationInfo?.quotationHeader?.preferredBrands;
    if (Array.isArray(preferredBrandsValue) && preferredBrandsValue.length > 0) {
      const valueIds = preferredBrandsValue.map((brand: any) => {
        if (typeof brand === "object") {
          if (brand.brandId || brand.id) return (brand.brandId || brand.id)?.toString();
          if (brand.brandName) return brand.brandName;
        }
        const fromOptions = brandOptions.find(
          (opt) => opt.value === brand || opt.label === brand
        );
        return fromOptions?.value || (typeof brand === "string" ? brand : "");
      }).filter(Boolean);
      const formatted = preferredBrandsValue.map((brand: any) => {
        if (typeof brand === "object") {
          const hasId = brand.brandId || brand.id;
          return {
            brandId: hasId ? (brand.brandId || brand.id)?.toString() : null,
            brandName: brand.brandName || brand.name || "",
          };
        }
        return { brandId: null, brandName: typeof brand === "string" ? brand : "" };
      });
      setNewPreferredBrandsArray(valueIds);
      setNewPreferredBrands(JSON.stringify(formatted));
      form2?.setFieldValue("supplierPreferredBrands", valueIds);
    }
  }, [OriginalData?.supplierInfo?.supplierHeader?.supplierPreferredBrands, OriginalData?.quotationInfo?.quotationHeader?.preferredBrands, brandOptions]);

  const areAllRowsFilled = () => {
    let allFilled = true;

    selectedRowKeys.forEach((key) => {
      const row = data.find((item: any) => item.quotationLineId == key);
      if (row) {
        const hsn = form.getFieldValue(`hsn_${row.quotationLineId}`);
        const leadDays = form.getFieldValue(`leadDays_${row.quotationLineId}`);

        if (pricingMode === "MRP") {
          const sellingPrice = form.getFieldValue(
            `sellingPrice_${row.quotationLineId}`
          );
          const discount = form.getFieldValue(
            `discount_${row.quotationLineId}`
          );

          // Check if any required field is missing or invalid for MRP
          if (
            !sellingPrice ||
            discount === undefined ||
            discount < 0 ||
            leadDays === undefined ||
            leadDays <= 0
          ) {
            allFilled = false;
          }
        } else {
          const price = form.getFieldValue(`price_${row.quotationLineId}`);

          // Check if any required field is missing or invalid
          if (!price || leadDays === undefined || leadDays <= 0) {
            allFilled = false;
          }
        }
      }
    });

    return allFilled;
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }: any) => {
    const handleChange = (value: any) => {
      form.setFieldsValue({
        [`${dataIndex}_${record.quotationLineId}`]: value,
      });
    };

    const validateMinPurchaseQuantity = (rule: any, value: any) => {
      const supplyQuantity =
        form.getFieldValue(`supplyQuantity_${record.quotationLineId}`) ||
        record.quantity ||
        0;
      if (value > supplyQuantity) {
        return Promise.reject(
          `${title} should not be greater than Supply Quantity (${supplyQuantity})`
        );
      }
      return Promise.resolve();
    };

    const validateLeadDays = (rule: any, value: any) => {
      if (value <= 0) {
        return Promise.reject(`${title} must be greater than 0`);
      }
      return Promise.resolve();
    };

    const isMRP = pricingMode === "MRP";
    const isPriceDisabled = isMRP && dataIndex === "price";

    // Calculate price from sellingPrice and discount for MRP mode
    const calculatePrice = () => {
      if (isMRP && dataIndex === "price") {
        const sellingPrice = editing
          ? form.getFieldValue(`sellingPrice_${record.quotationLineId}`) ||
            record.sellingPrice ||
            0
          : record.sellingPrice || 0;
        const discount = editing
          ? form.getFieldValue(`discount_${record.quotationLineId}`) ||
            record.discount ||
            0
          : record.discount || 0;
        if (sellingPrice > 0) {
          return sellingPrice - (discount * sellingPrice) / 100;
        }
        return 0;
      }
      return record[dataIndex] || 0;
    };

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex + `_${record.quotationLineId}`}
            style={{ margin: 0 }}
            initialValue={record[dataIndex]}
            rules={
              dataIndex === "leadDays"
                ? [
                    {
                      validator: validateLeadDays,
                    },
                  ]
                : dataIndex === "minPurchaseQuantity"
                ? [
                    {
                      validator: validateMinPurchaseQuantity,
                    },
                  ]
                : dataIndex === "leadDays"
                ? [
                    {
                      type: "number",
                      min: 1,
                      message: `${title} must be a whole number greater than 0`,
                    },
                  ]
                : dataIndex === "cgst" ||
                  dataIndex === "igst" ||
                  dataIndex === "sgst"
                ? [
                    {
                      type: "number",
                      min: 0,
                      message: `${title} must be greater than or equal to 0`,
                    },
                  ]
                : dataIndex === "leadDays"
                ? [
                    {
                      type: "number",
                      min: 1,
                      message: "Delivery Lead Days must be greater than 0",
                    },
                  ]
                : dataIndex === "sellingPrice" || dataIndex === "discount"
                ? [
                    {
                      required: true,
                      message: `${title} is required`,
                    },
                    {
                      type: "number",
                      min: 0,
                      message: `${title} must be greater than or equal to 0`,
                    },
                  ]
                : []
            }
          >
            {dataIndex === "hsn" ? (
              <Form.Item
                name={dataIndex + `_${record.quotationLineId}`}
                style={{ margin: 0 }}
                rules={[
                  {
                    required: false,
                    pattern: /^[0-9]{4,8}$/,
                    message: "HSN should be a number with 4 to 8 digits",
                  },
                ]}
              >
                <InputNumber
                  className="w-100"
                  parser={(value: any) => value.replace(/\D/g, "")} // Removes non-numeric characters
                  onKeyPress={(event) => {
                    const regex = /^[0-9\b]+$/; // Restrict to numbers and backspace
                    if (!regex.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={form.getFieldValue(
                    `${dataIndex}_${record.quotationLineId}`
                  )}
                  onChange={handleChange}
                />
              </Form.Item>
            ) : dataIndex === "price" && isMRP ? (
              <Form.Item
                name={dataIndex + `_${record.quotationLineId}`}
                style={{ margin: 0 }}
                dependencies={[
                  `sellingPrice_${record.quotationLineId}`,
                  `discount_${record.quotationLineId}`,
                ]}
              >
                {() => {
                  const sellingPrice =
                    form.getFieldValue(
                      `sellingPrice_${record.quotationLineId}`
                    ) ||
                    record.sellingPrice ||
                    0;
                  const discount =
                    form.getFieldValue(`discount_${record.quotationLineId}`) ||
                    record.discount ||
                    0;
                  const calculatedPrice =
                    sellingPrice > 0
                      ? sellingPrice - (discount * sellingPrice) / 100
                      : 0;
                  // Update the form field value
                  form.setFieldsValue({
                    [`price_${record.quotationLineId}`]: calculatedPrice,
                  });
                  return (
                    <InputNumber
                      className="w-100"
                      disabled={true}
                      value={calculatedPrice}
                      formatter={(value: any) => {
                        if (isNaN(value)) return "";
                        const hasDecimal = value.toString().includes(".");
                        return value
                          ? new Intl.NumberFormat("en-IN", {
                              style: "decimal",
                              minimumFractionDigits: hasDecimal ? 2 : 0,
                              maximumFractionDigits: hasDecimal ? 2 : 0,
                            }).format(value)
                          : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                      }}
                    />
                  );
                }}
              </Form.Item>
            ) : (
              <InputNumber
                className="w-100"
                formatter={(value: any) => {
                  if (isNaN(value)) return "";
                  const hasDecimal = value.toString().includes(".");
                  return value
                    ? new Intl.NumberFormat("en-IN", {
                        style: "decimal",
                        minimumFractionDigits: hasDecimal ? 2 : 0,
                        maximumFractionDigits: hasDecimal ? 2 : 0,
                      }).format(value)
                    : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }}
                parser={(value: any) => value!.replace(/\$\s?|(,*)/g, "")}
                onChange={(value) => {
                  handleChange(value);
                  // Auto-calculate price when sellingPrice or discount changes in MRP mode
                  if (
                    isMRP &&
                    (dataIndex === "sellingPrice" || dataIndex === "discount")
                  ) {
                    const sellingPrice =
                      dataIndex === "sellingPrice"
                        ? value
                        : form.getFieldValue(
                            `sellingPrice_${record.quotationLineId}`
                          ) || 0;
                    const discount =
                      dataIndex === "discount"
                        ? value
                        : form.getFieldValue(
                            `discount_${record.quotationLineId}`
                          ) || 0;
                    const calculatedPrice =
                      sellingPrice - (discount * sellingPrice) / 100;
                    form.setFieldsValue({
                      [`price_${record.quotationLineId}`]: calculatedPrice,
                    });
                  }
                }}
                defaultValue={Number(record[dataIndex])}
                min={
                  dataIndex === "cgst" ||
                  dataIndex === "igst" ||
                  dataIndex === "sgst" ||
                  dataIndex === "supplyQuantity" ||
                  dataIndex === "minPurchaseQuantity" ||
                  dataIndex === "sellingPrice" ||
                  dataIndex === "discount"
                    ? 0 // Allow decimal values for tax fields and MRP fields
                    : 1 // Enforce integer values for supplyQuantity, minPurchaseQuantity, and leadDays
                }
                step={
                  dataIndex === "cgst" ||
                  dataIndex === "igst" ||
                  dataIndex === "sgst" ||
                  dataIndex === "price" ||
                  dataIndex === "supplyQuantity" ||
                  dataIndex === "minPurchaseQuantity" ||
                  dataIndex === "sellingPrice" ||
                  dataIndex === "discount"
                    ? 0.01 // Allow decimals for tax fields and MRP fields
                    : 1 // Force integer input for supplyQuantity, minPurchaseQuantity, leadDays
                }
                onKeyPress={(event) => {
                  if (
                    dataIndex === "cgst" ||
                    dataIndex === "igst" ||
                    dataIndex === "sgst" ||
                    dataIndex === "price" ||
                    dataIndex === "supplyQuantity" ||
                    dataIndex === "minPurchaseQuantity" ||
                    dataIndex === "sellingPrice" ||
                    dataIndex === "discount"
                  ) {
                    // Allow numbers and decimal point for tax fields and MRP fields
                    if (!/^[0-9.]+$/.test(event.key)) {
                      event.preventDefault();
                    }
                  } else {
                    // Allow only numbers (no decimals) for other fields
                    if (!/^[0-9]+$/.test(event.key)) {
                      event.preventDefault();
                    }
                  }
                }}
              />
            )}
          </Form.Item>
        ) : dataIndex === "price" && isMRP ? (
          <span>{formatCurrency(calculatePrice(), "INR")}</span>
        ) : dataIndex === "sellingPrice" || dataIndex === "discount" ? (
          dataIndex === "discount" ? (
            <span>{Number(record[dataIndex] || 0).toFixed(2)}%</span>
          ) : (
            <span>{formatCurrency(record[dataIndex] || 0, "INR")}</span>
          )
        ) : (
          children
        )}
      </td>
    );
  };

  const columns = [
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text: any, record: any, index: number) => index + 1,
    },

    {
      title: "Material",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
      fixed: "left",
    },
    {
      title: "Specification",
      dataIndex: "specification",
      key: "specification",
      width: 200,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      width: 150,
      render: (text: any, record: any) => `${Number(text)} ${record.uomName}`,
    },
    {
      title: "Need By Date",
      dataIndex: "needByDate",
      width: 200,
      render: (text: any, record: any) =>
        `${dayjs(text).format("DD-MMM-YYYY")}`,
    },
    {
      title: "Supply Qty",
      dataIndex: `supplyQuantity`,
      key: "supplyQuantity",
      width: 120,
      editable: true,
    },
    {
      title: "Min Purchase Qty",
      dataIndex: `minPurchaseQuantity`,
      key: "minPurchaseQuantity",
      width: 150,
      editable: true,
    },
    {
      title: "HSN",
      dataIndex: `hsn`,
      key: "hsn",
      width: 120,
      editable: true,
    },
    {
      title: "Selling Price *",
      dataIndex: "sellingPrice",
      key: "sellingPrice",
      width: 200,
      editable: true,
    },
    {
      title: "Discount (%) *",
      dataIndex: "discount",
      key: "discount",
      width: 150,
      editable: true,
    },
    {
      title: "Price *(With Out Tax)",
      dataIndex: "price",
      key: "price",
      width: 250,
      editable: true,
    },
    {
      title: "SGST (%)",
      dataIndex: "sgst",
      key: "sgst",
      width: 200,
      editable: true,
    },
    {
      title: "CGST (%)",
      dataIndex: "cgst",
      key: "cgst",
      width: 200,
      editable: true,
    },
    {
      title: "IGST (%)",
      dataIndex: "igst",
      key: "igst",
      width: 200,
      editable: true,
    },
    {
      title: "Delivery Lead Days *",
      dataIndex: "leadDays",
      key: "leadDays",
      width: 250,
      editable: true,
    },
    // {
    //   title: "Line Total",
    //   dataIndex: "lineTotal",
    //   key: "lineTotal",
    //   width: 250,
    //   render: (text: any, record: any) => {
    //     if (text) {
    //       return <div>{formatCurrency(text, "INR")}</div>
    //     }
    //     else {
    //       // Retrieve current values from the form
    //       const supplyQuantity =
    //         form.getFieldValue(`supplyQuantity_${record.quotationLineId}`) || 0;
    //       const price = form.getFieldValue(`price_${record.quotationLineId}`) || 0;
    //       const sgst = form.getFieldValue(`sgst_${record.quotationLineId}`) || 0;
    //       const cgst = form.getFieldValue(`cgst_${record.quotationLineId}`) || 0;
    //       const igst = form.getFieldValue(`igst_${record.quotationLineId}`) || 0;

    //       // Calculate the line total
    //       const totalGst = sgst + cgst + igst;
    //       const lineTotal = supplyQuantity * price * (1 + totalGst / 100);

    //       return <div>{lineTotal.toFixed(2)}</div>;
    //     }
    //   },
    // },
  ];

  const mergedColumns = (columns: any, extra: any) => {
    const { gstType, pricingMode } = extra;
    return columns.map((col: any) => {
      if (!col.editable) {
        return col;
      }
      if (
        gstType == "igst" &&
        (col.dataIndex == "sgst" || col.dataIndex == "cgst")
      ) {
        col = { ...col, hidden: true };
      } else if (gstType == "cgst+sgst" && col.dataIndex == "igst") {
        col = { ...col, hidden: true };
      }

      // Hide Selling Price and Discount columns when pricing mode is not MRP
      if (
        pricingMode !== "MRP" &&
        (col.dataIndex === "sellingPrice" || col.dataIndex === "discount")
      ) {
        col = { ...col, hidden: true };
      }
      // Hide Price column when pricing mode is MRP (but keep it for calculation display)
      // Actually, we want to show it but disabled, so we don't hide it

      return {
        ...col,
        onCell: (record: any) => ({
          record,
          inputType: col.dataIndex === "quantity" ? "number" : "text",
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
          render: (text: any, record: any) => {
            if (col.dataIndex === "sgst") {
              return (
                <>
                  {text} ({record.sgstData})
                </>
              );
            }
            if (col.dataIndex === "cgst") {
              return (
                <>
                  {text} ({record.cgstData})
                </>
              );
            }
            if (col.dataIndex === "igst") {
              return (
                <>
                  {text} ({record.igstData})
                </>
              );
            }
            if (col.dataIndex === "price" && pricingMode === "MRP") {
              const sellingPrice =
                form.getFieldValue(`sellingPrice_${record.quotationLineId}`) ||
                record.sellingPrice ||
                0;
              const discount =
                form.getFieldValue(`discount_${record.quotationLineId}`) ||
                record.discount ||
                0;
              const calculatedPrice =
                sellingPrice > 0
                  ? sellingPrice - (discount * sellingPrice) / 100
                  : 0;
              return (
                <div style={{ textAlign: "right" }}>
                  {formatCurrency(calculatedPrice, "INR")}
                </div>
              );
            }
            if (col.dataIndex === "price") {
              return (
                <div style={{ textAlign: "right" }}>
                  {formatCurrency(text || 0, "INR")}
                </div>
              );
            }
            return text;
          },
        }),
      };
    });
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (!newSelectedRowKeys) {
      // If the user deselects all rows
      editingKeys.forEach((key) => {
        const row = data.find((item: any) => item.quotationLineId == key);
        form.setFieldsValue({
          [`supplyQuantity_${row.quotationLineId}`]: null,
        });
        form.setFieldsValue({
          [`minPurchaseQuantity_${row.quotationLineId}`]: null,
        });
        form.setFieldsValue({ [`hsn_${row.quotationLineId}`]: null });
        form.setFieldsValue({ [`price_${row.quotationLineId}`]: null });
        if (pricingMode === "MRP") {
          form.setFieldsValue({
            [`sellingPrice_${row.quotationLineId}`]: null,
          });
          form.setFieldsValue({ [`discount_${row.quotationLineId}`]: null });
        }
        form.setFieldsValue({ [`sgst_${row.quotationLineId}`]: null });
        form.setFieldsValue({ [`cgst_${row.quotationLineId}`]: null });
        form.setFieldsValue({ [`igst_${row.quotationLineId}`]: null });
        form.setFieldsValue({ [`leadDays_${row.quotationLineId}`]: null });
      });
      setEditingKeys(() => []);
      form.resetFields();
    }
    const unSelectedRowKeys = selectedRowKeys.filter(
      (key) => !newSelectedRowKeys.includes(key)
    );
    unSelectedRowKeys?.forEach((key) => {
      // If the user deselects a row
      const row = data.find((item: any) => item.quotationLineId == key);
      form.setFieldsValue({ [`supplyQuantity_${row.quotationLineId}`]: null });
      form.setFieldsValue({
        [`minPurchaseQuantity_${row.quotationLineId}`]: null,
      });
      form.setFieldsValue({ [`hsn_${row.quotationLineId}`]: null });
      form.setFieldsValue({ [`price_${row.quotationLineId}`]: null });
      if (pricingMode === "MRP") {
        form.setFieldsValue({ [`sellingPrice_${row.quotationLineId}`]: null });
        form.setFieldsValue({ [`discount_${row.quotationLineId}`]: null });
      }
      form.setFieldsValue({ [`sgst_${row.quotationLineId}`]: null });
      form.setFieldsValue({ [`cgst_${row.quotationLineId}`]: null });
      form.setFieldsValue({ [`igst_${row.quotationLineId}`]: null });
      form.setFieldsValue({ [`leadDays_${row.quotationLineId}`]: null });
    });
    setEditingKeys(newSelectedRowKeys); // Set the editing keys

    // const editableRowKeys: any = [];
    // newSelectedRowKeys?.forEach((key) => {
    //   // If the user selects a row
    //   const row = data.find((item: any) => item.quotationLineId == key);
    //   if (row) {
    //     form.setFieldsValue({
    //       [`supplyQuantity_${row.quotationLineId}`]: row.quantity, // Auto-fill supplyQuantity with quantity
    //       [`minPurchaseQuantity_${row.quotationLineId}`]:
    //         row.minPurchaseQuantity || null,
    //       [`hsn_${row.quotationLineId}`]: row.hsn || null,
    //       [`price_${row.quotationLineId}`]: row.price || null,
    //       [`sgst_${row.quotationLineId}`]: row.sgst || null,
    //       [`cgst_${row.quotationLineId}`]: row.cgst || null,
    //       [`igst_${row.quotationLineId}`]: row.igst || null,
    //       [`leadDays_${row.quotationLineId}`]: row.leadDays || null,
    //     });
    //     editableRowKeys.push(row.quotationLineId);
    //   }
    // });
    // setEditingKeys(editableRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleChangeAttachment = (info: any) => {
    let files = info.fileList.slice(-3); // Limit to 3 files
    setDocumentsAttached(files);
  };

  const beforeUpload = (file: any) => {
    const isLt2M = file.size / 1024 / 1024 <= 2;
    const isValidType = ["application/pdf", "image/jpeg", "image/png"].includes(
      file.type
    );

    if (!isLt2M) {
      Swal.fire({
        icon: "error",
        title: "File size should be less than 2MB",
      });
    }

    if (!isValidType) {
      Swal.fire({
        icon: "error",
        title: "File type should be pdf, jpeg or png",
      });
    }

    return isLt2M && isValidType;
  };

  const showDrawer = async () => {
    try {
      const rows = await form.validateFields();
      const invoiceLines: any = [];
      console.log("DATA:::DRAER", data);
      data.forEach((item: any) => {
        const isEdited = editingKeys.includes(item.quotationLineId);
        const supplyQuantity = isEdited
          ? rows[`supplyQuantity_${item.quotationLineId}`] || item.quantity
          : item.supplyQuantity || item.quantity;
        const minPurchaseQuantity = isEdited
          ? rows[`minPurchaseQuantity_${item.quotationLineId}`]
          : item.minPurchaseQuantity;
        const hsn = isEdited ? rows[`hsn_${item.quotationLineId}`] : item.hsn;

        let price, sellingPrice, discount;
        if (pricingMode === "MRP") {
          sellingPrice = isEdited
            ? rows[`sellingPrice_${item.quotationLineId}`]
            : item.sellingPrice || 0;
          discount = isEdited
            ? rows[`discount_${item.quotationLineId}`]
            : item.discount || 0;
          // Calculate price from selling price and discount
          price =
            sellingPrice > 0
              ? sellingPrice - (discount * sellingPrice) / 100
              : 0;
        } else {
          price = isEdited ? rows[`price_${item.quotationLineId}`] : item.price;
          sellingPrice = null;
          discount = null;
        }

        const sgstData = isEdited
          ? rows[`sgst_${item.quotationLineId}`]
          : item.sgst;
        const cgstData = isEdited
          ? rows[`cgst_${item.quotationLineId}`]
          : item.cgst;
        const igstData = isEdited
          ? rows[`igst_${item.quotationLineId}`]
          : item.igst || 0;
        const leadDays = isEdited
          ? rows[`leadDays_${item.quotationLineId}`]
          : item.leadDays;

        // Calculate the amounts
        const basicAmount = supplyQuantity * price;
        const sgst = (basicAmount * Number(sgstData)) / 100;
        const igst = (basicAmount * Number(igstData)) / 100;
        const cgst = (basicAmount * Number(cgstData)) / 100;
        invoiceLines.push({
          ...item,
          supplyQuantity,
          sgstData,
          cgstData,
          igstData,
          minPurchaseQuantity,
          basicAmount,
          sgst,
          igst,
          cgst,
          hsn,
          price,
          sellingPrice,
          discount,
          leadDays,
          grossTotal: basicAmount + sgst + igst + cgst,
        });
      });
      console.log("invoiceLines:::1111", invoiceLines);
      setInvoiceableLines(invoiceLines);
      setRequiredDOC(OriginalData?.quotationInfo?.requiredDocs);
      // Sync preferred brands to form when drawer opens
      form2.setFieldsValue({
        supplierPreferredBrands: newPreferredBrandsArray?.length > 0 ? newPreferredBrandsArray : [],
      });
      setDrawerVisible(true);
    } catch (error) {
      console.log(error);
    }
  };

  const previewColumns = [
    {
      title: "Material",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
    },
    {
      title: "Specification",
      dataIndex: "specification",
      key: "specification",
      width: 200,
    },
    {
      title: "Supply Qty",
      dataIndex: "supplyQuantity",
      key: "supplyQuantity",
      width: 120,
      render: (text: any) => (
        <div style={{ textAlign: "right" }}>{Number(text)}</div>
      ),
    },
    {
      title: "Selling Price",
      dataIndex: "sellingPrice",
      key: "sellingPrice",
      width: 150,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text || 0, "INR")}</span>
        </div>
      ),
    },
    {
      title: "Discount (%)",
      dataIndex: "discount",
      key: "discount",
      width: 120,
      render: (text: any) => (
        <div style={{ textAlign: "right" }}>
          {Number(text || 0).toFixed(2)}%
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: 150,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text || 0, "INR")}</span>
        </div>
      ),
    },
    {
      title: "SGST (%)",
      dataIndex: "sgst",
      key: "sgst",
      width: 150,
      render: (text: any, record: any) => {
        const percentage = record.sgstData;
        const amount = text;
        const hasPercentage =
          percentage !== null &&
          percentage !== undefined &&
          !isNaN(percentage) &&
          percentage !== "";
        const hasAmount =
          amount !== null &&
          amount !== undefined &&
          !isNaN(amount) &&
          amount !== "";

        if (!hasPercentage && !hasAmount) {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {hasPercentage ? `${percentage}%` : "N/A"} (
              {hasAmount ? formatCurrency(amount, "INR") : "N/A"})
            </span>
          </div>
        );
      },
    },
    {
      title: "CGST (%)",
      dataIndex: "cgst",
      key: "cgst",
      width: 150,
      render: (text: any, record: any) => {
        const percentage = record.cgstData;
        const amount = text;
        const hasPercentage =
          percentage !== null &&
          percentage !== undefined &&
          !isNaN(percentage) &&
          percentage !== "";
        const hasAmount =
          amount !== null &&
          amount !== undefined &&
          !isNaN(amount) &&
          amount !== "";

        if (!hasPercentage && !hasAmount) {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {hasPercentage ? `${percentage}%` : "N/A"} (
              {hasAmount ? formatCurrency(amount, "INR") : "N/A"})
            </span>
          </div>
        );
      },
    },
    {
      title: "IGST (%)",
      dataIndex: "igst",
      key: "igst",
      width: 150,
      render: (text: any, record: any) => {
        const percentage = record.igstData;
        const amount = text;
        const hasPercentage =
          percentage !== null &&
          percentage !== undefined &&
          !isNaN(percentage) &&
          percentage !== "";
        const hasAmount =
          amount !== null &&
          amount !== undefined &&
          !isNaN(amount) &&
          amount !== "";

        if (!hasPercentage && !hasAmount) {
          return (
            <div style={{ textAlign: "right" }}>
              <span>N/A</span>
            </div>
          );
        }
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {hasPercentage ? `${percentage}%` : "N/A"} (
              {hasAmount ? formatCurrency(amount, "INR") : "N/A"})
            </span>
          </div>
        );
      },
    },
    {
      title: "Line Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 250,
      render: (text: any, record: any) => {
        const { price, supplyQuantity, sgst, cgst, igst } = record;
        const overalPrice = (price || 0) * (supplyQuantity || 0);
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(
                overalPrice + (sgst || 0) + (cgst || 0) + (igst || 0) || 0,
                "INR"
              )}
            </span>
          </div>
        );
      },
    },
  ];

  const mergedPreviewColumns = (columns: any, extra: any) => {
    const { gstType, pricingMode } = extra;
    return columns.map((col: any) => {
      if (
        gstType == "igst" &&
        (col.dataIndex == "sgst" || col.dataIndex == "cgst")
      ) {
        col = { ...col, hidden: true };
      } else if (gstType == "cgst+sgst" && col.dataIndex == "igst") {
        col = { ...col, hidden: true };
      }

      // Hide Selling Price and Discount columns when pricing mode is not MRP
      if (
        pricingMode !== "MRP" &&
        (col.dataIndex === "sellingPrice" || col.dataIndex === "discount")
      ) {
        col = { ...col, hidden: true };
      }

      return col;
    });
  };

  const closeDrawer = () => {
    form2.resetFields();
    setDrawerVisible(false);
  };

  const fetchCurrentUserInfo = async () => {
    try {
      const res = await usersApis.getCurrentUser();

      if (res) {
        const { prefferedStates } = res;
        setPrefferedStates(prefferedStates?.map((item: any) => item?.stateID));
        setOrgId(res.orgid);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchOrderDetails = async () => {
    try {
      const res = await quotationApis.latestByQuotationId(rfq.quotationId);
      const { response, status, message } = res;
      if (status) {
        setOriginalData(response.data);
        // Set pricing mode from response
        if (response?.data?.quotationInfo?.quotationHeader?.pricingMode) {
          setPricingMode(
            response.data.quotationInfo.quotationHeader.pricingMode
          );
        }
        if (response?.data?.quotationInfo?.requiredDocs?.length > 0) {
          const _signature = response?.data?.quotationInfo?.requiredDocs?.find(
            (item: any) => item.moduleFileType == "signature"
          );
          if (_signature) {
            setSignature({
              docId: _signature?.docId,
              fileName: _signature?.fileName,
              image: _signature?.filePath,
              moduleFileType: _signature?.moduleFileType,
              module: _signature?.module,
              label: _signature?.signatureLabel,
              isActive: true,
            });
          }
        }

        const _attachments =
          response?.data?.quotationInfo?.quotationHeader.dms?.filter(
            (item: any) => item.moduleFileType == "attachments"
          );
        if (_attachments) {
          setAttachments(
            _attachments.map((attachment: any) => ({
              docId: attachment?.docId,
              name: attachment?.fileName,
              link: attachment?.filePath,
              moduleFileType: attachment?.moduleFileType,
              module: attachment?.module,
              label: "attachments",
              isActive: true,
            }))
          );
        }

        const _termsAndConditions =
          response?.data?.quotationInfo?.quotationHeader.dms?.find(
            (item: any) => item.moduleFileType == "termsAndConditions"
          );
        if (_termsAndConditions) {
          const data: any = await fetchHtmlContentFromUrl(
            _termsAndConditions?.filePath
          );
          setTermsAndConditions(data);
        }
        const _instructions =
          response?.data?.quotationInfo?.quotationHeader.dms?.find(
            (item: any) => item.moduleFileType == "instructions"
          );
        if (_instructions) {
          const data: any = await fetchHtmlContentFromUrl(
            _instructions?.filePath
          );
          setInstructions(data);
        }
        let materialData = response?.data?.supplierInfo?.supplierLines?.map(
          (item: any) => {
            return { ...item.quotationLines, ...item };
          }
        );
        const _DeliveryAddressList: any = [];
        const _needByDateList: any = [];
        const LineItems = materialData?.map((item: any) => {
          if (
            response?.data?.quotationInfo?.quotationHeader?.deliveryDateType ==
            "LINE_LEVEL"
          ) {
            if (
              !_DeliveryAddressList?.find(
                (address: any) => address?.id == item?.deliveryAddressName?.id
              )
            ) {
              _DeliveryAddressList.push({ ...item?.deliveryAddressName });
            }
          }
          //   if (data?.needByDateType == "LINE_LEVEL") {
          //     if (
          //       !_needByDateList?.find((date: any) => date == item?.needByDate)
          //     ) {
          //       _needByDateList.push(item?.needByDate);
          //     }
          //   }
          const file = item?.dms;
          if (file) {
            item.file = file[0];
          }
          return item;
        });

        setData(LineItems);
        setFilterData(LineItems);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBrandsFromQuotationApi = async () => {
    if (!rfq?.quotationId) return;
    try {
      const res: any = await quotationApis.latestByQuotationId(rfq.quotationId);
      const { response, status } = res || {};
      const data = response?.data || res?.data;
      if (!status || !data) return;

      const brandsRaw =
        data.preferredBrands ||
        data.quotationInfo?.quotationHeader?.preferredBrands ||
        data.supplierInfo?.supplierHeader?.preferredBrands ||
        data.supplierInfo?.supplierHeader?.supplierPreferredBrands ||
        data.brands ||
        data.brandList ||
        [];
      const brandsList = Array.isArray(brandsRaw) ? brandsRaw : [];

      const toOption = (b: any) => {
        if (typeof b === "string") return { label: b, value: b };
        const label = b.brandName || b.name || b.label || "";
        const value = (b.brandId || b.id || b.value || label).toString();
        return { label: label || value, value };
      };

      const optionsMap = new Map<string, { label: string; value: string }>();
      brandsList.forEach((b: any) => {
        const opt = toOption(b);
        if (opt.value) optionsMap.set(opt.value, opt);
      });

      const supplierPreferred =
        data.supplierInfo?.supplierHeader?.supplierPreferredBrands || [];
      const supplierList = Array.isArray(supplierPreferred) ? supplierPreferred : [];
      supplierList.forEach((b: any) => {
        const opt = toOption(b);
        if (opt.value && !optionsMap.has(opt.value)) {
          optionsMap.set(opt.value, opt);
        }
      });

      setBrandOptions(Array.from(optionsMap.values()));
    } catch (error) {
      console.log(error);
    }
  };

  const buildSupplierPreferredBrandsPayload = (values: string[]) =>
    values.map((val) => {
      const opt = brandOptions.find((o) => o.value === val);
      if (opt) {
        return { brandId: val, brandName: opt.label };
      }
      return { brandId: null, brandName: val };
    });

  const handlePreferredBrandsChange = (value: string[]) => {
    setNewPreferredBrandsArray(value);
    const formatted = buildSupplierPreferredBrandsPayload(value);
    setNewPreferredBrands(JSON.stringify(formatted));
    form2?.setFieldValue("supplierPreferredBrands", value);
  };

  const ViewTableTotals = ({
    data,
    additionalCharges,
    invoice,
    currency,
  }: any) => {
    let totalNetAmount = 0,
      cgst = 0,
      sgst = 0,
      igst = 0,
      totalAmount = 0;

    invoiceableLines?.forEach((item: any) => {
      const price = item.price || 0;
      const supplyQuantity = item.supplyQuantity || 0;
      const cgstData = item.cgstData || 0;
      const sgstData = item.sgstData || 0;
      const igstData = item.igstData || 0;

      const totalAmountForItem = price * supplyQuantity;

      // Calculate CGST, SGST, and IGST based on valid amounts
      const itemCGST = (totalAmountForItem * cgstData) / 100;
      const itemSGST = (totalAmountForItem * sgstData) / 100;
      const itemIGST = (totalAmountForItem * igstData) / 100;

      // Add to totals
      totalNetAmount += totalAmountForItem;
      cgst += itemCGST;
      sgst += itemSGST;
      igst += itemIGST;
    });

    totalAmount = totalNetAmount + cgst + sgst + igst;

    // Additional charges, if any
    additionalCharges?.forEach((item: any) => {
      if (item.price) {
        totalAmount += item.price;
      }
    });
    // console.log("totalNetAmount",totalNetAmount)

    // setTaxableData({
    //   netTotal: totalNetAmount,
    //   cgst: cgst,
    //   sgst: sgst,
    //   igst: igst,
    //   gross: totalAmount,
    // });
    return (
      <Row
        className={`${invoice ? "w-50 mt-2" : ""}`}
        style={{ margin: "20px" }}
      >
        <Col className={`justify-end`}>
          <div className={`${invoice ? "w-100" : "w-40"}`}>
            <div className="d-flex justify-content-between">
              <div className="w-50 justify-end">
                <strong>Taxable Amount</strong>
              </div>
              <span className="r_align">
                {formatCurrency(totalNetAmount, "INR")}
              </span>
            </div>
            {cgst && sgst ? (
              <>
                <div className="d-flex justify-content-between">
                  <div className="w-50 justify-end">
                    <strong>CGST</strong>
                  </div>
                  <span className="r_align">{formatCurrency(cgst, "INR")}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="w-50 justify-end">
                    <strong>SGST</strong>
                  </div>
                  <span className="r_align">{formatCurrency(sgst, "INR")}</span>
                </div>
              </>
            ) : (
              <div className="d-flex justify-content-between">
                <div className="w-50 justify-end">
                  <strong>IGST</strong>
                </div>
                <span className="r_align">{formatCurrency(igst, "INR")}</span>
              </div>
            )}
            {additionalCharges?.map((item: any) =>
              item.price ? (
                <div className="d-flex justify-content-between" key={item.name}>
                  <div className="w-50 justify-end">
                    <strong>{item.name}</strong>
                  </div>
                  <span className="r_align">
                    {formatCurrency(item.price, "INR")}
                  </span>
                </div>
              ) : null
            )}
            <div
              className="d-flex justify-content-between"
              style={{ fontSize: "18px", marginTop: "10px" }}
            >
              <div className="w-50 justify-end">
                <strong>Total</strong>
              </div>
              <strong className="r_align">
                {formatCurrency(totalAmount, "INR")}
              </strong>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  useEffect(() => {
    fetchCurrentUserInfo();
    fetchOrderDetails();
    fetchBrandsFromQuotationApi();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const ShowBillingAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressline1,
      addressline2,
      city,
      pincode,
      state,
      district,
      countryInfo,
    } = address;
    const { cin, gstin, pan, phoneNumber } =
      OriginalData?.quotationInfo?.quotationHeader;

    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>{deliveryLocationName}</strong>
        </li>
        <li>{addressline1}</li>
        <li>{addressline2}</li>
        <li>
          {city}, {district?.districtName}, {state?.stateName},{" "}
          {countryInfo?.countryName} - {pincode}
        </li>
        <li>
          <strong>GSTIN</strong> : {gstin}
        </li>
        <li>
          <strong>CIN</strong> : {cin}
        </li>
        <li>
          <strong>PAN</strong> : {pan}
        </li>
        <li>
          <strong>Phone</strong> : {phoneNumber}
        </li>
      </ul>
    );
  };
  const ShowDeliveryAddress = ({ address }: any) => {
    if (!address) return <></>;
    const {
      deliveryLocationName,
      addressLine1,
      addressLine2,
      city,
      pincode,
      state,
      district,
      countryInfo,
    } = address;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>{deliveryLocationName}</strong>
        </li>
        <li>{addressLine1}</li>
        <li>{addressLine2}</li>
        <li>
          {city}, {district?.districtName}, {state?.stateName},{" "}
          {countryInfo?.countryName} - {pincode}
        </li>
        <li>
          <strong>Contact Person</strong> : {address?.contactPersonName}
        </li>
        <li>
          <strong>Mobile Number</strong> : {address?.mobileNumber}
        </li>
      </ul>
    );
  };

  const uploadProps = {
    beforeUpload: (file: any) => {
      // Perform any file validation or processing here
      return false; // Return false to prevent auto-upload
    },
    maxCount: 1,
  };

  useEffect(() => {
    let _filterData = data;
    setFilterData(_filterData);
  }, [data]);

  const createInvoice = async (Data: any) => {
    try {
      const _formData = new FormData();
      const supplierApprovals: any = approvals?.data;
      const filesData = [];
      if (supplierTermsAndConditions) {
        const termsAndConditionsFile = new Blob([supplierTermsAndConditions], {
          type: "text/html",
        });
        _formData.append(
          `files`,
          new File([termsAndConditionsFile], "termsAndConditions.html", {
            type: "text/html",
          })
        );
        filesData.push({
          fileIndex: filesData.length,
          module: "Quotation",
          moduleFileType: "termsAndConditions",
          level: "HEADER_LEVEL",
        });
      }
      if (Data?.attachDC) {
        Data?.attachDC?.forEach((item: any) => {
          _formData.append(`files`, item?.originFileObj);
          filesData.push({
            fileIndex: filesData.length,
            module: "Quotation",
            moduleFileType: "attachments",
            level: "HEADER_LEVEL",
          });
        });
      }
      const docEntries = Object.entries(Data).filter(([key]) =>
        key.startsWith("doc_")
      );
      docEntries.forEach(([key, value]: any, index) => {
        const docNumberStr = key.slice(4); // Remove 'doc_' prefix
        const docNumber = parseInt(docNumberStr, 10);
        if (!isNaN(docNumber) && value && value.length > 0) {
          filesData.push({
            quotationDocNameId: docNumber,
            fileIndex: filesData.length,
            module: "Quotation",
            moduleFileType: "Supplier Docs",
            level: "LINE_LEVEL",
          });
          console.log("key", key, value);
          if (value[0]) {
            _formData.append(`files`, new File([value[0]], value[0]?.name));
          } else {
            console.log(`Skipping ${key} because value is undefined or empty`);
          }
        }
      });
      delete Data.attachDC;
      const keysToDelete = Object.keys(Data).filter((key) =>
        key.startsWith("doc_")
      );
      keysToDelete.forEach((key) => {
        delete Data[key]; // Delete each key from the copied object
      });
      let validityDate = dayjs(Data?.invoiceDate).format("DD-MMM-YYYY");
      let paymentPercentage = Data?.advancePercentage;
      let supplierPreferredBrands =
        newPreferredBrandsArray?.length > 0
          ? buildSupplierPreferredBrandsPayload(newPreferredBrandsArray)
          : Data?.supplierPreferredBrands && Array.isArray(Data.supplierPreferredBrands) && Data.supplierPreferredBrands.length > 0
            ? (typeof Data.supplierPreferredBrands[0] === "string"
              ? buildSupplierPreferredBrandsPayload(Data.supplierPreferredBrands)
              : Data.supplierPreferredBrands)
            : newPreferredBrands
              ? (() => {
                  try {
                    const parsed = JSON.parse(newPreferredBrands);
                    return Array.isArray(parsed) ? parsed : [];
                  } catch (e) {
                    return [];
                  }
                })()
              : OriginalData?.quotationInfo?.quotationHeader?.preferredBrands;
      delete Data.invoiceDate;
      delete Data.advancePercentage;
      delete Data.supplierPreferredBrands;

      let approvalRequired = Data?.approvals;
      delete Data?.approvals;

      let totalNetAmount = 0,
        cgst = 0,
        sgst = 0,
        igst = 0,
        totalAmount = 0;

      invoiceableLines?.forEach((item: any) => {
        console.log("item", item, item.price * item.supplyQuantity);
        const totalAmountForItem = item.price * item.supplyQuantity;
        console.log("111", totalAmountForItem);
        const itemCGST = (totalAmountForItem * item.cgstData) / 100;
        console.log("itemCGST", itemCGST);
        const itemSGST = (totalAmountForItem * item.sgstData) / 100;
        console.log("itemSGST", itemSGST);
        const itemIGST = (totalAmountForItem * item.igstData) / 100;
        console.log("itemIGST", itemIGST);

        totalNetAmount += totalAmountForItem;
        cgst += itemCGST;
        sgst += itemSGST;
        igst += itemIGST;
      });
      console.log("totalNetAmount", totalNetAmount);

      totalAmount = totalNetAmount + cgst + sgst + igst;
      console.log("Data.paymentDays", Data);
      if (
        Data?.paymentDays === undefined &&
        OriginalData?.quotationInfo?.quotationHeader?.expectedCreditDays
      ) {
        Data.paymentDays =
          OriginalData?.quotationInfo?.quotationHeader?.expectedCreditDays;
      }
      const supplierData: any = {
        supplierHeader: {
          ...Data,
          approvalRequired,
          validityDate,
          paymentPercentage,
          supplierPreferredBrands,
          netTotal: totalNetAmount,
          cgst: !isNaN(cgst) ? cgst.toFixed(2) : "0.00",
          sgst: !isNaN(sgst) ? sgst.toFixed(2) : "0.00",
          igst: !isNaN(igst) ? igst.toFixed(2) : "0.00",
          gross: !isNaN(totalAmount) ? totalAmount : 0,

          status: "QUOTED",
          signatureLabel: invoiceSignature?.label || "Authorised Signatory",
          quotationId: OriginalData.quotationInfo.quotationHeader.quotationId,
          rfqId: OriginalData.quotationInfo.quotationHeader.rfqId,
          // supplierId: 110,
          additionalChargesArray: additionalCharges?.map((charge: any) => {
            return {
              name: charge?.name,
              price: charge?.price,
            };
          }),
        },
        supplierLines: invoiceableLines.map((item: any) => {
          const lineData: any = {
            // supplierQuoteLineId:
            // supplierQuoteId: 123,
            quotationId: OriginalData.quotationInfo.quotationHeader.quotationId,
            rfqId: OriginalData.quotationInfo.quotationHeader.rfqId,
            // version: 1,
            quotationLineId: item.quotationLineId,
            minQty: item.minPurchaseQuantity,
            suppliedQty: item.supplyQuantity,
            hsn: item.hsn,
            sgst:
              item?.sgstData !== undefined && item?.sgstData !== null
                ? Number(item.sgstData.toFixed(2))
                : null,
            cgst:
              item?.cgstData !== undefined && item?.cgstData !== null
                ? Number(item.cgstData.toFixed(2))
                : null,
            igst:
              item?.igstData !== undefined && item?.igstData !== null
                ? Number(item.igstData.toFixed(2))
                : null,
            leadDays: item.leadDays,
            lineTotal: item.grossTotal,
          };

          // Add price or sellingPrice/discount based on pricing mode
          if (pricingMode === "MRP") {
            lineData.sellingPrice = item.sellingPrice;
            lineData.discount = item.discount;
            lineData.price = item.price; // Also send calculated price
          } else {
            lineData.price = item.price;
          }

          return lineData;
        }),
      };

      console.log("taxData", supplierData.supplierHeader);

      if (invoiceSignature?.image) {
        const image = base64ToFile(invoiceSignature?.image, "signature.png");
        supplierData.signatureLabel = invoiceSignature?.label;
        _formData.append("files", image);
        filesData.push({
          fileIndex: filesData.length,
          module: "quotations",
          moduleFileType: "signature",
          level: "HEADER_LEVEL",
          action: "Create",
        });
      }

      _formData.append(
        "supplierHeader",
        JSON.stringify(supplierData.supplierHeader)
      );
      _formData.append(
        "supplierLines",
        JSON.stringify(supplierData.supplierLines)
      );
      _formData.append(
        "requiredDocs",
        JSON.stringify(OriginalData?.quotationInfo?.requiredDocs)
      );
      _formData.append("docKeys", JSON.stringify(filesData));
      _formData.append("supplierApprovals", JSON.stringify(supplierApprovals));
      // _formData.append("files", JSON.stringify([]));
      // console.log("_formData", _formData);
      // return
      const response = await quotationApis.submitSupplierQuote(_formData);
      const { status, message, data } = response;
      if (status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Quoted Successfully",
        });
        closeDrawer();
        navigate("/view-rfqs");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: message,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.log(error);
    }
    setDisableCreateQuoteSubmit(false);
  };

  const regretSupplier = async () => {
    try {
      const res = await quotationApis.regretSupplier(
        OriginalData?.supplierInfo?.supplierHeader?.quotationId,
        orgId
      );
      const { status, message, response }: any = res;
      if (status === true) {
        Swal.fire("Regretted!", message, "success");
        navigate("/quoted_view");
      } else {
        Swal.fire("Error!", response, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableRegret(false);
  };

  function base64ToFile(base64String: string, fileName: string) {
    const byteString = atob(base64String.split(",")[1]);
    const mimeString = base64String.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: mimeString });
    return new File([blob], fileName, { type: mimeString });
  }

  return isLoading == true ? (
    <>
      <Flex align="center" gap="middle" className="pageLoader">
        <Spin size="large" />
      </Flex>
    </>
  ) : (
    <>
      <Head title="View Quotation Details" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {/* <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
                sm ? "content-active" : ""
              }`}
            >
              <QuotationsAside updateSm={setSm} sm={sm} />
            </div> */}
            <div className="card-inner card-inner-lg">
              {sm && mobileView && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">
                      <span>
                        RFQ -{" "}
                        {OriginalData?.quotationInfo?.quotationHeader?.rfqId}
                        {/* |{" "} */}
                        {/* {OriginalData?.quotationInfo?.quotationHeader?.status}{" "} */}
                      </span>
                    </BlockTitle>
                  </BlockHeadContent>

                  <div className="d-flex">
                    <div className="actions clearfix">
                      <ul
                        className="m-auto d-flex align-items-center justify-content-center p-0"
                        style={{
                          flexDirection: "row-reverse",
                        }}
                      >
                        <li className="pt-0 pb-0">
                          {disableRegret ? (
                            <Button color="primary" type="button">
                              <Spinner size="sm" color="light" />
                            </Button>
                          ) : (
                            <Button
                              color="secondary"
                              onClick={() => {
                                setDisableRegret(true);
                                Swal.fire({
                                  title: "Are you sure?",
                                  text: "Do you want to Regretted?",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Yes, Regret!",
                                  cancelButtonText: "No, cancel",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    regretSupplier();
                                    // Swal.fire(
                                    //     "Regretted!",
                                    //     "Your changes have been reverted.",
                                    //     "success"
                                    // );
                                  }
                                });
                              }}
                              type="button"
                              className="btn-dim btn btn-secondary"
                            >
                              Regret
                            </Button>
                          )}
                        </li>
                        <li className="pt-0 pb-0">
                          <Button
                            className="toggle"
                            color="primary"
                            onClick={async () => {
                              navigate("/view-rfqs");
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${
                        sm ? "active" : ""
                      }`}
                      onClick={() => setSm(!sm)}
                    >
                      <Icon name="menu-alt-r" />
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <div className="content clearfix">
                <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                  <Panel header="General Information" key="1">
                    <ul className="nav nav-tabs nav-tabs-card nav-tabs-xs w-100 p-0 m-0 position-relative">
                      <li className="nav-item" onClick={() => setTab("1")}>
                        <a
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                          className={`nav-link${tab === "1" ? " active" : ""}`}
                          href="#year"
                        >
                          General Info
                        </a>
                      </li>
                      <li className="nav-item" onClick={() => setTab("2")}>
                        <a
                          href="#overview"
                          onClick={(ev) => {
                            ev.preventDefault();
                          }}
                          className={`nav-link${tab === "2" ? " active" : ""}`}
                        >
                          Delivery Info
                        </a>
                      </li>
                      {tab == "2" &&
                        OriginalData?.quotationInfo?.quotationHeader
                          ?.needByDateType == "order Level" && (
                          <span
                            className="cursor-pointer position-absolute"
                            style={{
                              right: 20,
                              top: 10,
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (tab === "2") {
                                setValue(
                                  "inwardRequired",
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.inwardRequired
                                );
                                setValue(
                                  "needByDateType",
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.needByDateType
                                );
                                setValue(
                                  "needByDate",
                                  dayjs(
                                    OriginalData?.quotationInfo?.quotationHeader
                                      ?.needByDate
                                  )
                                );
                                setValue(
                                  "billingAddress",
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.deliveryAddress?.deliveryLocationName
                                );
                                setValue(
                                  "deliveryAddressType",
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.deliveryAddressType
                                );
                                setValue(
                                  "deliveryAddress",
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.deliveryAddress?.deliveryLocationName
                                );
                              }
                            }}
                          >
                            <Icon name="edit" />
                          </span>
                        )}
                    </ul>

                    <div className="tab-content mt-0">
                      {tab === "1" && (
                        <div className={`tab-pane${tab === "1" && " active"}`}>
                          <div style={{ margin: "1%" }}>
                            <Descriptions
                              title=""
                              className="custom-description-title"
                            >
                              <Descriptions.Item label="Customer">
                                {
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.orgName
                                }
                              </Descriptions.Item>
                              <Descriptions.Item label="Site">
                                {
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.siteName
                                }
                              </Descriptions.Item>
                              <Descriptions.Item label="Description">
                                <Descriptions.Item label="Description">
                                  <Popover
                                    content={
                                      <div>
                                        <p>
                                          {
                                            OriginalData?.quotationInfo
                                              ?.quotationHeader
                                              ?.quotationDescription
                                          }
                                        </p>
                                      </div>
                                    }
                                    title={"Description"}
                                  >
                                    {OriginalData?.quotationInfo
                                      ?.quotationHeader?.quotationDescription
                                      ?.length > 40 ? (
                                      <span
                                        style={{
                                          color: "#2263b3",
                                          textDecoration: "underline",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {OriginalData?.quotationInfo?.quotationHeader?.quotationDescription?.substring(
                                          0,
                                          40
                                        )}
                                        ...
                                      </span>
                                    ) : (
                                      OriginalData?.quotationInfo
                                        ?.quotationHeader
                                        ?.quotationDescription || "NA"
                                    )}
                                  </Popover>
                                </Descriptions.Item>
                              </Descriptions.Item>
                              <Descriptions.Item label="Preferred Brands / Make">
                                {formatPreferredBrands(
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.preferredBrands
                                )}
                              </Descriptions.Item>
                              <Descriptions.Item label="Pricing Mode">
                                {OriginalData?.quotationInfo?.quotationHeader
                                  ?.pricingMode || "NA"}
                              </Descriptions.Item>
                              <Descriptions.Item label="Last Submission Date">
                                <span className="badge-dim badge bg-primary rounded-pill">
                                  <strong>
                                    {" "}
                                    {OriginalData?.quotationInfo
                                      ?.quotationHeader?.lastSubmissionDate &&
                                      dayjs(
                                        OriginalData?.quotationInfo
                                          ?.quotationHeader?.lastSubmissionDate
                                      ).format("DD-MMM-YYYY")}
                                  </strong>
                                </span>
                              </Descriptions.Item>
                              <Descriptions.Item label="Submission Type">
                                {
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.deadlineType
                                }
                              </Descriptions.Item>
                              <Descriptions.Item label="Additional Charges">
                                {
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.additionalCharges
                                }
                              </Descriptions.Item>
                              <Descriptions.Item label="Payment Terms">
                                {
                                  OriginalData?.quotationInfo?.quotationHeader
                                    ?.paymentTerms
                                }
                              </Descriptions.Item>
                              {/* {OriginalData?.quotationInfo?.quotationHeader
                                ?.paymentTerms == "Advance" && (
                                <Descriptions.Item label="Advance">
                                  {OriginalData?.quotationInfo?.quotationHeader
                                    ?.advancePercentage || "--"}
                                  %
                                </Descriptions.Item>
                              )} */}
                              {OriginalData?.quotationInfo?.quotationHeader
                                ?.paymentTerms == "Credit" && (
                                <Descriptions.Item label="Credit Days">
                                  {OriginalData?.quotationInfo?.quotationHeader
                                    ?.expectedCreditDays || "--"}{" "}
                                  days
                                </Descriptions.Item>
                              )}
                            </Descriptions>
                          </div>
                        </div>
                      )}
                      {tab === "2" && (
                        <div className={`tab-pane${tab === "2" && " active"}`}>
                          <Col className="justify-start w-100  flex-wrap mt-3 p-0">
                            <div className="w-40  paddingLeft10 border-end">
                              <div className=" pt-1">
                                <div className="data-label w-90 mb-1">
                                  Billing Address
                                </div>
                                <div className="data-value w-90">
                                  <ShowBillingAddress
                                    address={
                                      OriginalData?.quotationInfo
                                        ?.quotationHeader?.billingAddressName
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            {OriginalData?.quotationInfo?.quotationHeader
                              ?.deliveryAddressId && (
                              <div className="w-40 paddingLeft10 ">
                                <div className=" pt-1">
                                  <div className="data-label w-9 mb-1">
                                    Delivery Address
                                  </div>
                                  <div className="data-value w-90">
                                    <ShowDeliveryAddress
                                      address={
                                        OriginalData?.quotationInfo
                                          ?.quotationHeader?.deliveryAddressName
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                            {OriginalData?.quotationInfo?.quotationHeader
                              ?.deliveryDateType === "ORDER_LEVEL" && (
                              <div className="w-20 paddingLeft10 ">
                                <div className=" pt-1">
                                  <div className="data-label w-9 mb-1">
                                    Need By Date
                                  </div>
                                  <div className="data-value w-90">
                                    {OriginalData?.quotationInfo
                                      ?.quotationHeader?.deliveryDate &&
                                      dayjs(
                                        OriginalData?.quotationInfo
                                          ?.quotationHeader?.deliveryDate
                                      ).format("DD-MMM-YYYY")}
                                  </div>
                                </div>
                              </div>
                            )}
                          </Col>
                        </div>
                      )}
                    </div>
                  </Panel>
                  <Panel header="Material Information" key="2">
                    <span ref={bulkUploadErrorsRef}></span>
                    <Form form={form} component={false}>
                      <div className="d-flex justify-content-between align-items-center m-0 p-0">
                        <div className="w-70 d-flex align-items-start">
                          <Form.Item
                            name="gstType"
                            label="GST Type"
                            className="mb-0 align-items-center"
                            style={{ width: 300 }}
                            rules={[{ required: true, message: "Required" }]}
                            initialValue="cgst+sgst"
                          >
                            <Select
                              allowClear={false}
                              placeholder="Select GST Type"
                              optionFilterProp="children"
                              defaultActiveFirstOption
                              onChange={(data: any) => {
                                setGstType(data);
                              }}
                              onSearch={(data: any) => {}}
                              filterOption={(input, option: any) =>
                                (option?.label ?? "")
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                            >
                              <Option value={"cgst+sgst"}>CGST + SGST</Option>
                              <Option value={"igst"}>IGST</Option>
                            </Select>
                          </Form.Item>
                        </div>

                        <BulkMaterialUpload
                          append={(data: any) => {
                            console.log("onUpload", data);
                            const { errorFlag, lines } = data;
                            if (errorFlag) {
                              setUploadedDataErrors(lines);
                            } else {
                              setUploadedDataErrors([]);
                            }
                            const quotationIds: any = [];
                            lines?.forEach((row: any, index: any) => {
                              const {
                                quotationLineId,
                                suppliedQty,
                                minQty,
                                hsn,
                                price,
                                sellingPrice,
                                discount,
                                leadDays,
                                sgst,
                                cgst,
                                igst,
                                errorFlag,
                              } = row;
                              if (errorFlag) return;
                              quotationIds.push(quotationLineId);
                              form.setFieldsValue({
                                [`supplyQuantity_${quotationLineId}`]:
                                  suppliedQty,
                              });
                              form.setFieldsValue({
                                [`minPurchaseQuantity_${quotationLineId}`]:
                                  minQty,
                              });
                              form.setFieldsValue({
                                [`hsn_${quotationLineId}`]: hsn,
                              });
                              if (pricingMode === "MRP") {
                                form.setFieldsValue({
                                  [`sellingPrice_${quotationLineId}`]:
                                    sellingPrice,
                                });
                                form.setFieldsValue({
                                  [`discount_${quotationLineId}`]: discount,
                                });
                                // Calculate price from sellingPrice and discount
                                if (sellingPrice && discount !== undefined) {
                                  const calculatedPrice =
                                    sellingPrice -
                                    (discount * sellingPrice) / 100;
                                  form.setFieldsValue({
                                    [`price_${quotationLineId}`]:
                                      calculatedPrice,
                                  });
                                }
                              } else {
                                form.setFieldsValue({
                                  [`price_${quotationLineId}`]: price,
                                });
                              }
                              form.setFieldsValue({
                                [`leadDays_${quotationLineId}`]: leadDays,
                              });
                              if (gstType == "cgst+sgst") {
                                form.setFieldsValue({
                                  [`sgst_${quotationLineId}`]: sgst,
                                });
                                form.setFieldsValue({
                                  [`cgst_${quotationLineId}`]: cgst,
                                });
                              } else {
                                form.setFieldsValue({
                                  [`igst_${quotationLineId}`]: igst,
                                });
                              }
                            });
                            onSelectChange(quotationIds);
                          }}
                          extra={{
                            igstFlag: gstType == "igst" ? 1 : 0,
                            quotationId: rfq?.quotationId,
                          }}
                        />
                      </div>
                      <Alert
                        isOpen={uploadedDataErrors?.length > 0}
                        color="danger"
                        className="start-0 w-100 py-1 mt-2"
                        style={{
                          top: 0,
                          textAlign: "left",
                          fontSize: "14px",
                          cursor: "default",
                        }}
                      >
                        <Icon name={"info"} style={{ top: "0.6rem" }} />
                        <span>
                          Failed to prefill the data in the table due to an
                          issue with the inserted rows. You can{" "}
                          <Popconfirm
                            title={<></>}
                            icon={<></>}
                            showCancel={false}
                            open={uploadedDataErrorModal}
                            okButtonProps={{
                              style: {
                                display: "none",
                              },
                            }}
                            onConfirm={() => {
                              try {
                                console.log("confirm");
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            onCancel={() => {
                              alert("cancel");
                            }}
                            onOpenChange={(visible) => {
                              setUploadedDataErrorModal(visible);
                            }}
                            // arrow={false}
                            description={
                              <div
                                style={{
                                  width: "60vw",
                                  maxHeight: "400px",
                                  overflow: "scroll",
                                }}
                              >
                                {uploadedDataErrors?.map((row: any) => {
                                  const {
                                    errorMessage,
                                    materialName,
                                    materialId,
                                    errorFlag,
                                  } = row;
                                  if (errorFlag) {
                                    return (
                                      <Alert
                                        color="danger"
                                        className="start-0 w-100 py-1 mt-2"
                                        style={{
                                          top: 0,
                                          textAlign: "left",
                                          fontSize: "14px",
                                          cursor: "default",
                                          display: "flex",
                                        }}
                                      >
                                        <strong>
                                          {materialName} (Id: {materialId})
                                          &nbsp; &nbsp;
                                        </strong>
                                        <ol>
                                          {errorMessage?.map((error: any) => (
                                            <li>{error}</li>
                                          ))}
                                        </ol>
                                      </Alert>
                                    );
                                  }
                                  return (
                                    <Alert
                                      color="success"
                                      className="start-0 w-100 py-1 mt-2"
                                      style={{
                                        top: 0,
                                        textAlign: "left",
                                        fontSize: "14px",
                                        cursor: "default",
                                        display: "flex",
                                      }}
                                    >
                                      <strong>
                                        {materialName} (Id: {materialId}) &nbsp;
                                        &nbsp;
                                      </strong>
                                      <ol>
                                        <li>This is a Valid record </li>
                                      </ol>
                                    </Alert>
                                  );
                                })}
                              </div>
                            }
                          >
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                bulkUploadErrorsRef?.current?.scrollIntoView({
                                  behavior: "smooth",
                                });
                                setUploadedDataErrorModal(true);
                              }}
                              target="_self"
                              style={{ textDecoration: "underline" }}
                            >
                              <strong>view the details</strong>
                            </a>
                            , update the file{" "}
                          </Popconfirm>
                          and reupload it.
                        </span>
                      </Alert>
                      <p className="ant-descriptions-item-content mb-2">
                        <strong>Note : </strong>
                        Please select the material and enter the required data.
                        Alternatively, you can{" "}
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();

                            // Prepating Excel obj
                            let excelData: any = [];
                            filterData?.forEach((row: any) => {
                              let obj: any = {
                                ID: row?.quotationLineId,
                                "Material Id": row?.materialId,
                                "Material Name": row?.materialName,
                                Specification: row?.specification,
                                Quantity:
                                  Number(row?.quantity) + " " + row?.uomName,
                                "Supply Quantity": "",
                                "Min Purchase Quantity": "",
                                HSN: "",
                                "Delivery Lead Days *": "",
                              };

                              // Add Selling Price and Discount columns for MRP mode
                              if (pricingMode === "MRP") {
                                obj["Selling Price"] = "";
                                obj["Discount (%)"] = "";
                                obj["Price *(Without Tax)"] = "";
                              } else {
                                obj["Price *(Without Tax)"] = "";
                              }

                              if (
                                OriginalData?.quotationInfo?.quotationHeader
                                  ?.deliveryDateType === "LINE_LEVEL"
                              ) {
                                obj["Need By Date"] = `${dayjs(
                                  row?.needByDate
                                ).format("DD-MMM-YYYY")}`;
                              }
                              if (
                                OriginalData?.quotationInfo?.quotationHeader
                                  ?.deliveryLevelType === "LINE_LEVEL"
                              ) {
                                try {
                                  const {
                                    addressLine1,
                                    addressLine2,
                                    cityName,
                                    stateName,
                                    countryName,
                                    pincode,
                                  } = row?.deliveryAddressName;
                                  obj["Delivery Address"] = [
                                    addressLine1,
                                    addressLine2,
                                    cityName,
                                    stateName,
                                    countryName,
                                    pincode,
                                  ]?.join(" ,");
                                } catch (error) {
                                  console.log(
                                    "error while destructuring deliveryAddressName"
                                  );
                                }
                              }
                              if (gstType == "cgst+sgst") {
                                obj["SGST (%)"] = "";
                                obj["CGST (%)"] = "";
                              } else {
                                obj["IGST (%)"] = "";
                              }
                              excelData.push(obj);
                            });
                            ExportToXlsx(
                              excelData,
                              OriginalData?.quotationInfo?.quotationHeader
                                ?.rfqId
                            );
                          }}
                          target="_self"
                          style={{ textDecoration: "underline" }}
                        >
                          download the template
                        </a>{" "}
                        to fill in the details and upload it.
                      </p>
                      <div className="table-responsive">
                        <div
                          style={{
                            width: screenSize - 150 + "px",
                            margin: "0px auto",
                          }}
                        >
                          <Table
                            className="customTable"
                            columns={mergedColumns(columns, {
                              gstType,
                              pricingMode,
                            })}
                            rowSelection={rowSelection}
                            components={{
                              body: {
                                cell: EditableCell,
                              },
                            }}
                            dataSource={filterData.map((item: any) => ({
                              ...item,
                              key: item?.quotationLineId,
                            }))}
                            scroll={{ x: 1000 }}
                            expandable={{
                              expandedRowRender: (record: any) => (
                                <div className="expandableBody">
                                  <div style={{ flex: 1, textAlign: "left" }}>
                                    <p style={{ margin: 0 }}>
                                      {record.description}
                                    </p>
                                    {record.file && (
                                      <div>
                                        <PaperClipOutlined /> &nbsp;
                                        <a
                                          href={record?.file?.fileName}
                                          download={record?.file?.fileName}
                                        >
                                          {record?.file?.fileName}
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                  {OriginalData?.quotationInfo?.quotationHeader
                                    ?.deliveryLevelType === "LINE_LEVEL" &&
                                    record.deliveryAddressName && (
                                      <div
                                        className="lineAddress"
                                        style={{ flex: 1 }}
                                      >
                                        <h6>Delivery Address</h6>
                                        <ShowAddressPopOver
                                          address={record.deliveryAddressName}
                                        />
                                      </div>
                                    )}
                                </div>
                              ),
                            }}
                            bordered
                            size="middle"
                            pagination={false}
                          />
                        </div>

                        <div className="d-flex justify-content-between align-items-center m-0 p-0 mt-2">
                          <div className="w-70 d-flex align-items-start"></div>
                          {selectedRowKeys.length > 0 && (
                            <Button
                              color="primary"
                              size="sm"
                              className="m-0"
                              style={{ height: 40 }}
                              onClick={async () => {
                                try {
                                  // Trigger form validation before proceeding
                                  await form.validateFields(); // Validate fields registered in the form

                                  if (areAllRowsFilled()) {
                                    showDrawer(); // Proceed with the preview if validation passes
                                  } else {
                                    message.error(
                                      "Please fill out all required fields."
                                    );
                                  }
                                } catch (errorInfo) {
                                  // Handle form validation failure
                                  message.error(
                                    "Validation failed: Please fill out all required fields."
                                  );
                                  console.log("Validation failed:", errorInfo);
                                }
                              }}
                              // disabled={selectedRowKeys.length === 0}
                            >
                              Show Preview
                            </Button>
                          )}
                        </div>
                      </div>
                    </Form>
                  </Panel>
                  <Panel header="Other Information" key="3">
                    <Descriptions title="" className="custom-description-title">
                      <Descriptions.Item label="Customer Instructions">
                        <span
                          style={{
                            color: "#2263b3",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => setInstructionsVisible(true)}
                        >
                          View Instructions
                        </span>
                      </Descriptions.Item>
                      <Descriptions.Item label="Customer Terms and Conditions">
                        <span
                          style={{
                            color: "#2263b3",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => setTermsVisible(true)}
                        >
                          View Terms and Conditions
                        </span>
                      </Descriptions.Item>
                      {attachments?.length > 0 && (
                        <Descriptions.Item label="">
                          <div>
                            <strong className="">
                              Attachments &nbsp;
                              <PaperClipOutlined />
                            </strong>
                            <div>
                              {attachments?.map(
                                (attachment: any, index: number) => (
                                  <div
                                    key={index}
                                    className="w-100 d-flex justify-content-between"
                                  >
                                    <div>
                                      <strong>{index + 1}.</strong>
                                      &nbsp;
                                      {attachment.name}
                                      &nbsp; &nbsp; &nbsp; &nbsp;
                                    </div>
                                    <div>
                                      <a
                                        href={attachment.link}
                                        download={attachment.link}
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                        }}
                                      >
                                        <DownloadOutlined />
                                      </a>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                  </Panel>
                </AntCollapse>

                <Drawer
                  title={
                    <div className="d-flex justify-content-between align-items-center">
                      <strong>Create Quotation</strong>
                      <div style={{ textAlign: "right" }}>
                        {disableCreateQuoteSubmit ? (
                          <Button color="primary" type="button">
                            <Spinner size="sm" color="light" />
                          </Button>
                        ) : (
                          <Button
                            onClick={(e) => {
                              form2.submit();
                              e.preventDefault();
                              errorRef?.current?.scrollIntoView({
                                behavior: "smooth",
                              });
                            }}
                            color="primary"
                            className="m-3 mt-0 mb-0"
                          >
                            Create Quotation
                          </Button>
                        )}
                      </div>
                    </div>
                  }
                  placement="right"
                  onClose={closeDrawer}
                  open={drawerVisible}
                  width="85vw"
                  style={{
                    position: "absolute",
                    zIndex: 1100,
                  }}
                  styles={{ body: { paddingBottom: 80 } }}
                >
                  <Form
                    initialValues={{
                      approvals: "N", // Set the default value here
                    }}
                    form={form2}
                    layout="vertical"
                    onFinish={(data) => {
                      if (!invoiceSignature?.image) {
                        Swal.fire({
                          icon: "info",
                          title: "Signature",
                          text: "Signature is required",
                        });
                        return;
                      }
                      Swal.fire({
                        title: "Are you sure?",
                        text: "You are about to create!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, Create!",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          setDisableCreateQuoteSubmit(true);
                          createInvoice(data);
                        }
                      });
                    }}
                    requiredMark={false}
                  >
                    <AntCollapse
                      defaultActiveKey={["1", "2", "3", "4"]}
                      className="mt-3"
                    >
                      <Panel
                        header={<h6>Billing & Other Information</h6>}
                        key="1"
                      >
                        <div className="d-flex justify-content-around ">
                          <div className="w-50">
                            <div className="justify-start w-100  flex-wrap pt-0">
                              <div className={` w-50  paddingLeft10`}>
                                <div className=" pt-1">
                                  <div className="data-label w-90 mb-1">
                                    Billing Address
                                  </div>
                                  <div className="data-value w-90">
                                    <ShowBillingAddress
                                      address={
                                        OriginalData?.quotationInfo
                                          ?.quotationHeader?.billingAddressName
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              {OriginalData?.quotationInfo?.quotationHeader
                                ?.deliveryAddressId && (
                                <div className="w-40 paddingLeft10 ">
                                  <div className=" pt-1">
                                    <div className="data-label w-9 mb-1">
                                      Delivery Address
                                    </div>
                                    <div className="data-value w-90">
                                      <ShowDeliveryAddress
                                        address={
                                          OriginalData?.quotationInfo
                                            ?.quotationHeader
                                            ?.deliveryAddressName
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="border-end"></div>
                          <div className="w-45">
                            <div className="justify-start w-100  flex-wrap pt-3">
                              <Form.Item
                                name="negotiable"
                                label={
                                  <div className="data-label w-90 mb-1">
                                    Negotiable
                                  </div>
                                }
                                className="w-50 p-3 paddingLeft10  pt-0 pb-0"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select type",
                                  },
                                ]}
                              >
                                <Select placeholder="Select">
                                  {/* <Option value="dc">Delivery Challan</Option> */}
                                  <Option value="Y">Yes</Option>
                                  <Option value="N">No</Option>
                                </Select>
                              </Form.Item>
                              <Form.Item
                                name="approvals"
                                label={
                                  <div className="data-label w-100 mb-1">
                                    Approval Required ?
                                  </div>
                                }
                                className="w-50 p-3 paddingLeft10 pt-0 pb-0"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select approvals",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select Approvals"
                                  value={approvalRequired}
                                  onChange={(e) => {
                                    form2.setFieldValue("approvals", e);
                                    setApprovalRequired(() => e);
                                  }}
                                  defaultValue="N"
                                >
                                  <Option value="Y">Yes</Option>
                                  <Option value="N">No</Option>
                                </Select>
                                {approvalRequired == "Y" && (
                                  <Popover
                                    content="Click here to set required approvals"
                                    title="Approval Required"
                                  >
                                    <a
                                      href="#"
                                      className="success"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setApprovals((pre) => {
                                          return {
                                            ...pre,
                                            open: true,
                                          };
                                        });
                                      }}
                                    >
                                      <EditOutlined /> Set Approvals &nbsp;
                                      {approvals?.data?.length == 0 ? (
                                        <span className="mandatory">
                                          Please set approvals
                                        </span>
                                      ) : (
                                        <></>
                                      )}
                                    </a>
                                  </Popover>
                                )}
                              </Form.Item>

                              <Form.Item
                                name="invoiceDate"
                                label={
                                  <div className="data-label w-90 mb-1">
                                    Validity Date
                                  </div>
                                }
                                className="w-50 p-3 paddingLeft10  pt-0 pb-0"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select Validity Date",
                                  },
                                ]}
                              >
                                <DatePicker
                                  className="w-100"
                                  placeholder="Validity Date"
                                  minDate={dayjs().add(0, "day")}
                                />
                              </Form.Item>

                              <Form.Item
                                name="supplierPreferredBrands"
                                label={
                                  <div className="data-label w-100 mb-1">
                                    Preferred Brands/Make
                                  </div>
                                }
                                className="w-50 p-2 paddingLeft10  pt-0 pb-0"
                                rules={[
                                  {
                                    required: false,
                                  },
                                ]}
                              >
                                <Select
                                  mode="tags"
                                  style={{ width: "100%", minHeight: "38px" }}
                                  placeholder="Select or type to add brands"
                                  value={newPreferredBrandsArray || []}
                                  onChange={(val: string[]) =>
                                    handlePreferredBrandsChange(val)
                                  }
                                  options={brandOptions}
                                  tokenSeparators={[","]}
                                  filterOption={(input, option) => {
                                    const label = option?.label?.toString()?.toLowerCase() || "";
                                    const val = option?.value?.toString()?.toLowerCase() || "";
                                    return label.includes(input.toLowerCase()) || val.includes(input.toLowerCase());
                                  }}
                                  maxTagCount="responsive"
                                  dropdownRender={(menu) => (
                                    <>
                                      {newPreferredBrandsArray?.length === brandOptions?.length ? (
                                        <>
                                          <a href="#" className="addNewItem" onClick={(e) => { e.preventDefault(); handlePreferredBrandsChange([]); }}>Clear All</a>
                                          <hr />
                                        </>
                                      ) : (
                                        <>
                                          {brandOptions?.length > 6 && (
                                            <a href="#" className="addNewItem" onClick={(e) => { e.preventDefault(); handlePreferredBrandsChange(brandOptions.map((o) => o.value)); }}>Select All</a>
                                          )}
                                          <hr />
                                        </>
                                      )}
                                      <div className="drop-down-multiselect">{menu}</div>
                                    </>
                                  )}
                                />
                              </Form.Item>

                              {paymentTerm === "Advance" && (
                                <>
                                  <Form.Item
                                    name="advancePercentage"
                                    label={
                                      <div className="data-label w-100 mb-1">
                                        Advance Percentage
                                      </div>
                                    }
                                    className="w-50 p-2 paddingLeft10  pt-0 pb-0"
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Please select Advance Percentage",
                                      },
                                    ]}
                                  >
                                    <Input
                                      className="w-100"
                                      type="number"
                                      placeholder="Enter Advance Percentage"
                                      // pattern={/^(0|[1-9][0-9]?|100)$/}
                                    />
                                  </Form.Item>
                                </>
                              )}
                              {OriginalData?.quotationInfo?.quotationHeader
                                ?.paymentTerms == "Credit" && (
                                <Form.Item
                                  name="paymentDays"
                                  label={
                                    <div className="data-label w-100 mb-1">
                                      Credit Days
                                    </div>
                                  }
                                  className="w-50 p-2 paddingLeft10  pt-0 pb-0"
                                  rules={[
                                    {
                                      required: false,
                                      message: "Please Enter Credit Days",
                                    },
                                  ]}
                                >
                                  <Input
                                    className="w-100"
                                    type="number"
                                    defaultValue={
                                      OriginalData?.quotationInfo
                                        ?.quotationHeader?.expectedCreditDays
                                    }
                                    placeholder="Enter Credit Days"
                                    onBlur={(e) => {
                                      if (!e.target.value) {
                                        // Set default value back if no input is provided
                                        e.target.value =
                                          OriginalData?.quotationInfo
                                            ?.quotationHeader
                                            ?.expectedCreditDays || "";
                                      }
                                    }}
                                  />
                                </Form.Item>
                              )}
                            </div>
                          </div>
                        </div>
                      </Panel>

                      <Panel header={<h6>Material Information</h6>} key="2">
                        <div className="table-responsive poTable">
                          <div
                            style={{
                              width: screenSize - 350 + "px",
                              margin: "0px auto 15px auto",
                            }}
                          >
                            <Table
                              className="customTable"
                              columns={mergedPreviewColumns(previewColumns, {
                                gstType,
                                pricingMode,
                              })}
                              dataSource={invoiceableLines}
                              scroll={{ x: 1000 }}
                              expandable={{
                                expandedRowRender: (record: any) => (
                                  <div className="expandableBody">
                                    <div style={{ flex: 1, textAlign: "left" }}>
                                      <p style={{ margin: 0 }}>
                                        {record.description}
                                      </p>
                                      {record.file && (
                                        <div>
                                          <PaperClipOutlined /> &nbsp;
                                          <a
                                            href={record?.file?.fileName}
                                            download={record?.file?.fileName}
                                          >
                                            {record?.file?.fileName}
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                    {/* {materialData?.deliveryAddressType ===
                                      "LINE_LEVEL" &&
                                      record.deliveryAddressId && (
                                        <div
                                          className="lineAddress"
                                          style={{ flex: 1 }}
                                        >
                                          <h6>Delivery Address</h6>
                                          <ShowAddressPopOver
                                            address={record.deliveryAddress}
                                          />
                                        </div>
                                      )} */}
                                  </div>
                                ),
                              }}
                              bordered
                              size="middle"
                              pagination={false}
                            />
                          </div>
                        </div>

                        <div className="d-flex">
                          <Row className="mt-2 w-50">
                            <div>
                              {OriginalData?.quotationInfo?.quotationHeader
                                ?.additionalCharges !== "Fixed" && (
                                <div className="d-flex align-items-center">
                                  <h6 className="m-1 mb-0">
                                    Additional Charges (If Any)
                                  </h6>
                                  <div className="w-20 m-1 mb-0">
                                    {editAdditionalCharges ? (
                                      <a
                                        type={undefined}
                                        onClick={() => {
                                          if (
                                            additionalCharges.find(
                                              (field: any, ind: number) => {
                                                const name =
                                                  form2.getFieldValue(
                                                    `AdditionalCharges.${field?.id}.name`
                                                  );
                                                const price =
                                                  form2.getFieldValue(
                                                    `AdditionalCharges.${field?.id}.price`
                                                  );
                                                return !name || !price;
                                              }
                                            )
                                          ) {
                                            return;
                                          }

                                          setAdditionalCharges([
                                            ...additionalCharges,
                                            {
                                              name: "",
                                              price: null,
                                              id: nanoid(4),
                                            },
                                          ]);
                                        }}
                                        className="addNewItem"
                                      >
                                        <PlusSquareOutlined />
                                      </a>
                                    ) : (
                                      <a
                                        type={undefined}
                                        onClick={() => {
                                          setEditAdditionalCharges(true);
                                        }}
                                        className="addNewItem"
                                      >
                                        <EditOutlined />
                                      </a>
                                    )}
                                  </div>
                                </div>
                              )}
                              {additionalCharges.map(
                                (field: any, index: number) => (
                                  <Row
                                    key={field.id}
                                    className="m-2 mb-0 w-100"
                                  >
                                    <div className="w-50">
                                      {editAdditionalCharges ? (
                                        <Form.Item
                                          name={`AdditionalCharges.${field.id}.name`}
                                          label={
                                            <strong>
                                              Additional Charge Name
                                            </strong>
                                          }
                                          rules={[
                                            {
                                              required: true,
                                              message:
                                                "Charge Name is required",
                                            },
                                          ]}
                                          className="mb-0"
                                        >
                                          <Input
                                            className="w-100"
                                            disabled={!editAdditionalCharges}
                                            autoComplete="off"
                                          />
                                        </Form.Item>
                                      ) : (
                                        <strong>{field.name}</strong>
                                      )}
                                    </div>
                                    <div className="w-30">
                                      {editAdditionalCharges ? (
                                        <Form.Item
                                          name={`AdditionalCharges.${field.id}.price`}
                                          label={<strong>Price (INR)</strong>}
                                          rules={[
                                            {
                                              required: true,
                                              message: "Price is required",
                                            },
                                          ]}
                                          className="mb-0"
                                        >
                                          <InputNumber
                                            min={0}
                                            step={0.01}
                                            disabled={!editAdditionalCharges}
                                            className="w-100"
                                            formatter={
                                              (value) =>
                                                `${value}`.replace(
                                                  /\B(?=(\d{3})+(?!\d))/g,
                                                  ","
                                                ) // Adds commas for thousands
                                            }
                                            parser={
                                              (value: any) =>
                                                value!.replace(
                                                  /\$\s?|(,*)/g,
                                                  ""
                                                ) // Removes commas and symbols
                                            }
                                            onKeyPress={(event) => {
                                              if (!/^[0-9.]$/.test(event.key)) {
                                                event.preventDefault(); // Prevent non-numeric and non-decimal input
                                              }
                                            }}
                                            autoComplete="off"
                                          />
                                        </Form.Item>
                                      ) : (
                                        <strong>
                                          {formatCurrency(field.price, "INR")}
                                        </strong>
                                      )}
                                    </div>
                                    <Col className="d-flex align-items-end w-15">
                                      {editAdditionalCharges && (
                                        <a
                                          // href="#dropdownitem"
                                          onClick={() => {
                                            form2.setFieldsValue({
                                              [`AdditionalCharges.${field.id}.name`]:
                                                "",
                                              [`AdditionalCharges.${field.id}.price`]:
                                                null,
                                            });
                                            const newAdditionalCharges: any =
                                              [];
                                            additionalCharges.forEach(
                                              (fld: any, ind: number) => {
                                                if (fld.id != field.id) {
                                                  const name =
                                                    form2.getFieldValue(
                                                      `AdditionalCharges.${fld.id}.name`
                                                    );
                                                  const price =
                                                    form2.getFieldValue(
                                                      `AdditionalCharges.${fld.id}.price`
                                                    );
                                                  if (name && price) {
                                                    newAdditionalCharges.push({
                                                      name,
                                                      price,
                                                      id: fld.id,
                                                    });
                                                  }
                                                }
                                              }
                                            );
                                            setAdditionalCharges(
                                              newAdditionalCharges
                                            );
                                          }}
                                          className="addNewItem"
                                        >
                                          <DeleteOutlined />
                                        </a>
                                      )}
                                    </Col>
                                  </Row>
                                )
                              )}
                              {additionalCharges.length > 0 &&
                                editAdditionalCharges && (
                                  <Button
                                    className="m-4 mt-3 mb-0"
                                    color="primary"
                                    onClick={() => {
                                      const newAdditionalCharges: any = [];
                                      additionalCharges.forEach(
                                        (field: any, index: number) => {
                                          const name = form2.getFieldValue(
                                            `AdditionalCharges.${field?.id}.name`
                                          );
                                          const price = form2.getFieldValue(
                                            `AdditionalCharges.${field?.id}.price`
                                          );
                                          if (name && price) {
                                            newAdditionalCharges.push({
                                              name,
                                              price,
                                              id: field?.id,
                                            });
                                          }
                                        }
                                      );
                                      setAdditionalCharges(() => {
                                        return newAdditionalCharges;
                                      });
                                      if (newAdditionalCharges.length != 0) {
                                        setEditAdditionalCharges(false);
                                      }
                                    }}
                                  >
                                    Save
                                  </Button>
                                )}
                            </div>
                          </Row>

                          <ViewTableTotals
                            data={invoiceableLines}
                            additionalCharges={additionalCharges}
                            invoice={true}
                          />
                        </div>
                        <Row className="m-4 justify-content-end ">
                          {invoiceSignature?.isActive ? (
                            <div className="signatureBtnWrapper">
                              <div className="d-flex justify-content-between align-items-center">
                                <strong>Signature</strong>
                                <a
                                  style={{
                                    fontSize: "14px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setInvoiceSignature((prev: any) => ({
                                      ...prev,
                                      isActive: false,
                                      image: null,
                                      label: "Authorised Signatory",
                                    }));
                                    setValue("signatureObj", {
                                      isActive: false,
                                      image: null,
                                      label: "Authorised Signatory",
                                    });
                                  }}
                                >
                                  <Icon
                                    name="cross"
                                    className="pointer"
                                    onClick={() => {
                                      setInvoiceSignature((prev: any) => ({
                                        ...prev,
                                        isActive: false,
                                        image: null,
                                        label: "Authorised Signatory",
                                      }));
                                      setValue("signatureObj", {
                                        isActive: false,
                                        image: null,
                                        label: "Authorised Signatory",
                                      });
                                    }}
                                  />
                                </a>
                              </div>
                              <div
                                style={{
                                  minHeight: invoiceSignature?.image
                                    ? "0px"
                                    : "120px",
                                  display: invoiceSignature?.image
                                    ? "block"
                                    : "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {!invoiceSignature?.image && (
                                  <Button
                                    color="btn-dim btn"
                                    onClick={() => {
                                      setShowCropModel(true);
                                    }}
                                  >
                                    <Icon
                                      name="upload-cloud"
                                      className="pointer"
                                      onClick={() => {
                                        setShowCropModel(true);
                                      }}
                                    />
                                    <span>Upload</span>
                                  </Button>
                                )}
                                {invoiceSignature?.image && (
                                  <>
                                    <div className="signatueImgWrapper border">
                                      <img
                                        src={invoiceSignature?.image}
                                        alt="Signed"
                                        style={{ width: "160px" }}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Button
                                        color="btn-dim btn"
                                        onClick={() => {
                                          setInvoiceSignature((pre: any) => {
                                            return { ...pre, image: null };
                                          });
                                        }}
                                      >
                                        <span>Reset</span>
                                        <Icon
                                          name="redo"
                                          className="pointer"
                                          onClick={() => {
                                            setInvoiceSignature((pre: any) => {
                                              return { ...pre, image: null };
                                            });
                                          }}
                                        />
                                      </Button>
                                    </div>
                                    <div>
                                      <div className="form-group">
                                        <label
                                          className="form-label"
                                          htmlFor="signatureLabel"
                                        >
                                          Signature Label
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="signatureLabel"
                                          onChange={(e) => {
                                            setInvoiceSignature((pre: any) => {
                                              return {
                                                ...pre,
                                                label: e.target.value,
                                              };
                                            });
                                          }}
                                          defaultValue={
                                            invoiceSignature?.label ||
                                            "Authorised Signatory"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>

                              {!invoiceSignature?.image && (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Button
                                      color="btn-dim btn"
                                      onClick={() =>
                                        setShowSignatureModel(true)
                                      }
                                    >
                                      <Icon name="pen" />
                                      <span>Use Signature Pad</span>
                                    </Button>
                                  </div>
                                </>
                              )}
                            </div>
                          ) : (
                            <div
                              style={{
                                border: "1px solid #e5ecf7",
                                backgroundColor: "#f7faff",
                                padding: "10px",
                                marginLeft: "10px",
                                width: "22%",
                                borderRadius: "5px",
                                textAlign: "center",
                              }}
                            >
                              <Button
                                color="btn-dim btn"
                                onClick={() => {
                                  setInvoiceSignature((pre: any) => {
                                    return { ...pre, isActive: true };
                                  });
                                }}
                              >
                                <Icon
                                  name="edit"
                                  className="pointer"
                                  onClick={() => {
                                    setInvoiceSignature((pre: any) => {
                                      return { ...pre, isActive: true };
                                    });
                                  }}
                                />
                                <span>Add Signature</span>
                              </Button>
                            </div>
                          )}
                        </Row>
                      </Panel>
                      <Panel header={<h6>Terms and Conditions</h6>} key="3">
                        <div>
                          {/* <ReactQuill
                            theme="snow"
                            value={supplierTermsAndConditions}
                            onChange={(data) => {
                              setsupplierTermsAndConditions(data);
                            }}
                            className="mb-3"
                          /> */}
                          <FormProvider {...methods}>
                            <form>
                              <FormTextArea
                                name="supplierTermsAndConditions"
                                label={undefined}
                                placeholder="Enter Terms and Conditions"
                              />
                            </form>
                          </FormProvider>
                        </div>
                      </Panel>
                      <Panel header={<h6>Attachments (If Any)</h6>} key="4">
                        <div className="w-100 d-flex m-2">
                          <div className="w-25">
                            <Form.Item
                              name="attachDC"
                              label={<strong>Attach Documents</strong>}
                              valuePropName="fileList"
                              getValueFromEvent={(e: any) => e?.fileList}
                              rules={[
                                {
                                  required: false,
                                  message:
                                    "Please upload at least one document.",
                                },
                              ]}
                            >
                              <Upload
                                beforeUpload={beforeUpload}
                                onChange={handleChangeAttachment}
                                multiple={true}
                                fileList={documentsAttached}
                                accept=".pdf,.jpg,.jpeg,.png"
                                className="w-100"
                                showUploadList={{ showPreviewIcon: false }}
                                itemRender={(
                                  originNode,
                                  file,
                                  fileList,
                                  actions
                                ) => {
                                  // Customize the rendering of each file to remove the tooltip
                                  return React.cloneElement(originNode, {
                                    title: null, // Removes the tooltip entirely
                                  });
                                }}
                              >
                                <AntButton icon={<UploadOutlined />}>
                                  Click to Upload
                                </AntButton>
                              </Upload>
                            </Form.Item>
                          </div>
                          {/* Debugging Output */}
                          {/* {JSON.stringify(requiredDOC)} */}

                          {/* Dynamic Form Items */}
                          <div className="row">
                            <div
                              className="col-md-12"
                              style={{ marginBottom: 15 }}
                            >
                              <h6>Required Docs</h6>
                            </div>
                            {requiredDOC &&
                              requiredDOC.length > 0 &&
                              requiredDOC.map((doc: any) => (
                                <div
                                  key={doc.quotationDocNameId}
                                  className="col-md-4"
                                >
                                  <span ref={errorRef}></span>
                                  <Form.Item
                                    key={doc.quotationDocNameId}
                                    name={`doc_${doc.quotationDocNameId}`}
                                    label={
                                      <strong>
                                        {doc.documentName}{" "}
                                        {doc.mandatory == 1 && (
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        )}
                                      </strong>
                                    }
                                    valuePropName="fileList"
                                    getValueFromEvent={(e: any) =>
                                      Array.isArray(e) ? e : e?.fileList
                                    }
                                    rules={[
                                      {
                                        required: doc.mandatory == 1,
                                        message: `${doc.documentName} is required`,
                                      },
                                    ]}
                                  >
                                    <Upload {...uploadProps} className="w-100">
                                      <AntButton icon={<UploadOutlined />}>
                                        Click to Upload
                                      </AntButton>
                                    </Upload>
                                  </Form.Item>
                                </div>
                              ))}
                          </div>
                        </div>
                      </Panel>
                    </AntCollapse>
                    {showCropModel && (
                      <CropperComponent
                        modal={showCropModel}
                        toggle={() => setShowCropModel(!showCropModel)}
                        onSave={(data: string) => {
                          setInvoiceSignature((pre: any) => {
                            return { ...pre, image: data };
                          });
                          setShowCropModel(false);
                        }}
                      />
                    )}
                    {showSignatureModel && (
                      <SignatureModal
                        modal={showSignatureModel}
                        toggle={() =>
                          setShowSignatureModel(!showSignatureModel)
                        }
                        onSave={(data: string) => {
                          setInvoiceSignature((pre: any) => {
                            return { ...pre, image: data };
                          });
                          setShowSignatureModel(false);
                        }}
                      />
                    )}
                  </Form>
                </Drawer>

                <AntModal
                  title="Instructions"
                  open={instructionsVisible}
                  footer={null}
                  onCancel={() => setInstructionsVisible(false)}
                  width="60%"
                  styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: instructions || "",
                    }}
                  />
                </AntModal>
                <AntModal
                  title="Terms and Conditions"
                  open={termsVisible}
                  footer={null}
                  onCancel={() => setTermsVisible(false)}
                  width="60%"
                  styles={{ body: { maxHeight: "70vh", overflowY: "auto" } }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: termsAndConditions || "",
                    }}
                  />
                </AntModal>
              </div>
            </div>
          </div>
        </Card>
      </Content>

      {approvals?.open && (
        <QuotationApprovalDrawer
          open={approvals.open}
          onClose={() => {
            setApprovals((pre) => {
              return {
                ...pre,
                open: false,
              };
            });
          }}
          onSubmit={(data: any) => {
            setApprovals({
              open: false,
              data: data,
            });
          }}
          stateIds={prefferedStates}
          setApprovalSubmissionStatus={(status: boolean) => {}}
          approvalData={approvals.data} // Pass the current approval data
        />
      )}
    </>
  );
};

const fetchHtmlContentFromUrl = async (url: string) => {
  try {
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "text/html",
      },
    });

    return response?.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
const ShowAddressPopOver = ({ address }: any) => {
  return (
    <ul>
      <li>{address.addressLine1}</li>
      <li>{address.addressLine2}</li>
      <li>
        {address.cityName}, {address.stateName}, {address.countryName} -{" "}
        {address.pincode}
      </li>
    </ul>
  );
};

export default RFQViewDetails;
